import Vue from 'vue'
import Router from 'vue-router'
import homepage from '@/components/pages/homepage'
import aboutUs from '@/components/pages/aboutus'
import practiceAreas from '@/components/pages/practice-areas'
import ourTeam from '@/components/pages/our-team'
import publications from '@/components/pages/publications'
import contact from '@/components/pages/contact'
import privacyPolicy from '@/components/pages/privacy-policy'
import cookiePolicy from '@/components/pages/cookie-policy'
import legalNotices from '@/components/pages/legal-notices'

import turkish from '@/views/turkish'
import { tr } from './tr'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: homepage,
      meta: { policy: true }
    },
    {
      path: '/tr',
      component: turkish,
      children: tr,
    },
    {
      path: '/about-us',
      name: 'aboutUs',
      component: aboutUs,
      meta: { policy: false }
    },
    {
      path: '/practice-areas',
      name: 'practiceAreas',
      component: practiceAreas
    },
    {
      path: '/our-team',
      name: 'ourTeam',
      component: ourTeam
    },
    {
      path: '/publications',
      name: 'publications',
      component: publications
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      component: privacyPolicy
    },
    {
      path: '/cookie-policy',
      name: 'cookiePolicy',
      component: cookiePolicy
    },
    {
      path: '/legal-notices',
      name: 'legalNotices',
      component: legalNotices
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js